var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeeBalanceInDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.4868 25.3836H48.7226V18.0171C48.7226 16.5848 47.5633 15.425 46.1306 15.425H28.8577C28.3633 23.2178 21.8837 29.4073 13.9721 29.4073C10.971 29.4073 8.19174 28.5205 5.85547 26.9858V45.2993C5.85547 48.1638 8.17459 50.5 11.0562 50.5H46.1319C47.5642 50.5 48.724 49.3407 48.724 47.908V41.4284H40.4882C36.0719 41.4284 32.4739 37.8304 32.4739 33.4141C32.4736 28.9811 36.0715 25.3835 40.4878 25.3835L40.4868 25.3836ZM44.8179 11.5201V8.91138C44.8179 7.47914 43.6585 6.31934 42.2258 6.31934H26.4877C27.5107 7.87113 28.2438 9.62726 28.6191 11.5201H44.8179Z",
    fill: "#E53E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.3703 28.623H40.4863C37.8605 28.623 35.729 30.7545 35.729 33.3804C35.729 36.0062 37.8605 38.1377 40.4863 38.1377H49.3703C49.7285 38.1377 50.0181 37.8476 50.0181 37.4899V29.2541C50.0181 28.9127 49.7281 28.623 49.3703 28.623ZM41.5775 35.3413C40.5035 35.3413 39.6337 34.4716 39.6337 33.3975C39.6337 32.3234 40.5034 31.4537 41.5775 31.4537C42.6516 31.4537 43.5213 32.3234 43.5213 33.3975C43.5213 34.4716 42.6516 35.3413 41.5775 35.3413Z",
    fill: "#E53E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.6726 0.5C6.13107 0.5 0 6.63107 0 14.1726C0 21.7141 6.13107 27.8451 13.6726 27.8451C21.2141 27.8451 27.3451 21.7141 27.3451 14.1726C27.3451 6.63107 21.2141 0.5 13.6726 0.5ZM18.6522 9.42315H15.7738C16.148 9.94116 16.407 10.5457 16.551 11.179H18.6522V13.2515L16.551 13.2513C16.0904 15.4388 14.1332 17.0796 11.8017 17.0796H11.3124L16.7814 22.635L13.7303 22.6352L8.69305 17.5403V14.8921H11.8018C12.9244 14.8921 13.8742 14.2012 14.2772 13.2513H8.69305V11.1788H14.2772C13.8742 10.2002 12.9244 9.53803 11.8018 9.53803L8.69305 9.53823V7.35067H18.6237V9.42314L18.6522 9.42315Z",
    fill: "#E53E3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeBalanceInDashboard);
export default __webpack_public_path__ + "static/media/FeeBalanceInDashboard.2e634067c1d0b57bc0d60308eb83956f.svg";
export { ForwardRef as ReactComponent };